import { useEffect, useState } from 'react';
import { registerBackgroundSync } from 'services/syncQueue';

/**
 * Returns the real-time network connection status.
 * When the connection is restored:
 *  - Registers a Background Sync tag (Chrome/Edge) so the SW can replay
 *    mutations even when the tab is in the background
 *  - Falls back to a direct processMutations() call (Safari/Firefox)
 */
export const useOnlineStatus = (): boolean => {
    const [isOnline, setIsOnline] = useState<boolean>(navigator.onLine);

    useEffect(() => {
        const handleOnline = async () => {
            setIsOnline(true);
            // Try Background Sync first; falls back to direct replay automatically
            await registerBackgroundSync();
        };

        const handleOffline = () => {
            setIsOnline(false);
        };

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    return isOnline;
};
